module.exports = __webpack_public_path__ + "static/social-3f956bd03fbe565766ef3679cbbff6d6.gif";